(() => {
  if (window.yhsBank11Loaded) return;
  window.yhsBank11Loaded = true;
  // Keep shared app launchers in a reserved footer area on Bank pages only.
  if (document.querySelector('.yhs-bank11') && !document.querySelector('.yhs-bank11 .collection-hero')) {
    const place = () => document.body.style.setProperty('--bank11-widget-offset', Math.max(0, Math.round(document.body.getBoundingClientRect().bottom - innerHeight)) + 'px');
    const observed = new WeakSet();
    const refresh = () => {
      const chat = document.querySelector('shopify-chat')?.shadowRoot;
      const tidio = document.querySelector('#tidio-chat')?.shadowRoot;
      const button = tidio?.querySelector('#button');
      document.body.toggleAttribute('data-bank11-shopify-open', Boolean(chat?.querySelector('[aria-expanded="true"], shopify-agent-runtime[open]')));
      document.body.toggleAttribute('data-bank11-tidio-open', button ? !button.classList.contains('chat-closed') : Boolean(tidio?.querySelector('[role="log"], [aria-label="Close chat widget"]')));
      [chat, tidio].filter(Boolean).forEach(root => {
        if (observed.has(root)) return;
        observed.add(root);
        new MutationObserver(refresh).observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['class', 'aria-expanded', 'open']});
      });
      place();
    };
    addEventListener('scroll', place, {passive:true});
    addEventListener('resize', place);
    new ResizeObserver(place).observe(document.body);
    new MutationObserver(refresh).observe(document.body, {childList:true});
    let attempts = 0;
    const connect = setInterval(() => {
      refresh();
      if (++attempts >= 60 || (document.querySelector('shopify-chat')?.shadowRoot && document.querySelector('#tidio-chat')?.shadowRoot)) clearInterval(connect);
    }, 500);
    refresh();
  }
  document.addEventListener('click', event => {
    const pin = event.target.closest('.yhs-bank11 .pin');
    if (pin) {
      const root = pin.closest('.yhs-bank11');
      root.querySelectorAll('.pin').forEach(p => p.setAttribute('aria-pressed', String(p === pin)));
      root.querySelectorAll('.interfaces li').forEach(li => li.classList.remove('active'));
      const item = root.querySelector('[id="' + pin.getAttribute('aria-controls') + '"]');
      if (item) {
        item.classList.add('active');
        if (matchMedia('(max-width:600px)').matches) {
          item.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          item.focus({ preventScroll:true });
        }
      }
    }
    const link = event.target.closest('.yhs-bank11 a[data-bank-peer],.yhs-bank11 a[data-bank-page]');
    if (link) {
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) { const url = new URL(link.href); url.searchParams.set('preview_theme_id', preview); link.href = url.href; }
    }
  });
})();
